<template>
    <div>
        <div id="contents" v-show="mode === MODE.SEARCH">
            <div class="contents_wrap">
                <h2 class="pg_title">{{pageTitle}}</h2>
                <!-- breadcrumbs -->
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
                <!-- //breadcrumbs -->
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w49">
                                <li class="tit_150">Request Type</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="selectedRequestType">
                                        <option value="ALL">ALL</option>
                                        <option
                                            v-for="item in availableRequestTypeList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w49">
                                <li class="tit_150">Approval Status</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="selectedApprovalStatus">
                                        <option value="ALL">ALL</option>
                                        <option
                                            v-for="item in availableApprovalStatusList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w49">
                                <li class="tit_150">Account No</li>
                                <li data-input-type="select" class="w100-150">
                                    <span class="clearable">
                                        <input
                                            type="text"
                                            class="text_input w100"
                                            v-model="accountNo"
                                            v-clearable
                                            maxlength="30"
                                            value
                                        />
                                    </span>
                                </li>
                            </ul>
                            <ul class="w49">
                                <li class="tit_150">Requester Name</li>
                                <li data-input-type="select" class="w100-150">
                                    <span class="clearable">
                                        <input
                                            type="text"
                                            class="text_input w100"
                                            maxlength="30"
                                            v-model="requestUser"
                                            v-clearable
                                            placeholder
                                            value
                                        />
                                    </span>
                                </li>
                            </ul>
                            <ul class="w100">
                                <li class="tit_150">Request Date</li>
                                <li data-input-type="date">
                                    <fieldset class="ui_fieldset">
                                        <label class="date-wrap">
                                            <input
                                                id="fromDate"
                                                type="text"
                                                class="date_input w100"
                                                placeholder="From Date"
                                                maxlength="20"
                                                readonly
                                            />
                                            <a href="javascript:" class="in_btn" id="icoFromDate">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">Open Calendar</span>
                                            </a>
                                        </label>
                                        <div id="from-picker-container" />
                                        <em class="txt_space"></em>
                                        <label class="date-wrap">
                                            <input
                                                id="toDate"
                                                type="text"
                                                class="date_input w100"
                                                placeholder="To Date"
                                                maxlength="20"
                                                readonly
                                            />
                                            <a href="javascript:" class="in_btn" id="icoToDate">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">Open Calendar</span>
                                            </a>
                                        </label>
                                        <div id="to-picker-container" style="margin-top: -1px;" />
                                    </fieldset>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                            </span>
                        </div>
                    </article>
                </div>
                <!-- Grid -->
                <div class="grid_wrap">
                    <!-- Grid Count-->
                    <div class="grid_total">
                        Total Count
                        <em>{{ resultCount | numberFormat }}</em>
                    </div>
                    <!-- Grid -->
                    <div id="grid">
                        <toast-grid
                            gridId="grid"
                            :key="gridKey"
                            :data="gridData"
                            :columns="gridColumns"
                            :options="gridOptions"
                            :pageOptions="gridPageOptions"
                            :theme="gridTheme"
                            :isTotalCount="false"
                            :click="onGridRowClick"
                        />
                    </div>
                </div>
                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="search"
                        align="center"
                    />
                </div>
            </div>
        </div>
        <approval-view
            v-if="mode === MODE.VIEW"
            :gubunCd="selectedGubunCd"
            :seqNo="selectedSeqNo"
            :onBackToList="onBackToList"
        ></approval-view>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import $ from 'jquery';

import qs from 'query-string';
import moment from 'moment';
// import 'tui-date-picker/dist/tui-date-picker.css';
// import DatePicker from 'tui-date-picker';

import { SDLUtil, DateUtil } from '@/utils';

import DatePicker from '~c/DatePicker';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import FirstApprovalView from './FirstApprovalView';

const MODE = {
    SEARCH: 1,
    VIEW: 2,
};
export default {
    name: 'hhp-first-approval',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'approval-view': FirstApprovalView,
    },
    computed: {},
    created() {
        this.init();
    },
    mounted() {
        this.rangePicker = DatePicker.createRangeWithOpener(
            'from-picker-container', 'fromDate', 'icoFromDate',
            'to-picker-container', 'toDate', 'icoToDate',
            { type: 'date', locale: 'en', showToday: false }
        );
    },
    data() {
        return {
            ...mapGetters({
                locale: 'getLocale',
            }),
            MODE,
            mode: MODE.SEARCH,

            availableRequestTypeList: [],
            availableApprovalStatusList: [],

            selectedRequestType: 'ALL',
            selectedApprovalStatus: '001', // Default status is 'Requested'

            accountNo: '',
            requestUser: '',

            rangePicker: null,

            startDate: {},
            endDate: {},

            searchToAddDt: '',
            searchFromAddDt: '',

            selectedGubunCd: '', // For Detail View
            selectedSeqNo: '', // For Detail View

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: 'Request Date',
                    name: 'SUB_REQ_TIME',
                    width: 100,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'User ID',
                    name: 'USER_ID',
                    width: 120,
                    align: 'left',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Requester Name',
                    name: 'NAME',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Request Type',
                    name: 'REQUEST_TYPE',
                    align: 'center',
                    resizable: true,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Status',
                    name: 'STATUS',
                    width: 220,
                    align: 'center',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Account No.',
                    name: 'ACCOUNT_NO',
                    width: 100,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: '1st Approval Date',
                    name: 'SUB_APP_TIME',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: '2nd Approval Date',
                    name: 'SUB_COMP_TIME',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            const { requestType, approvalStatus } = await this.fetchInitData();
            this.setAvailableRequestTypeList(requestType);
            this.setAvailableApprovalStatusList(approvalStatus);
            SDLUtil.showLoadingBar(false);

            this.search(1);
        },
        fetchInitData() {
            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/FirstApproval/FirstApproval.skp`)
                .then(res => {
                    Vue.$log.info('InitData RES ==> ', res);
                    return res.data;
                })
                .catch(err => {
                    // TODO Handle login required
                    Vue.$log.error('FirsrApprovalList ERROR ==> ', err);

                    if (['HHP_FORBIDDEN', '401', '403'].includes(err.data.error.code)) {
                        this.$router.push({path: '/basis/certificate/CertWarning'});
                        return err.data.error;
                    }
                });
        },
        setAvailableRequestTypeList(list) {
            this.availableRequestTypeList = list;
        },
        setAvailableApprovalStatusList(list) {
            this.availableApprovalStatusList = list;
            // this.selectedApprovalStatus = '001'; // Requested Status
        },

        // validateSearchParams() {
        //     return true;
        // },

        prepSearchParams(pageNo, exclude = []) {
            if (typeof pageNo !== 'number' || pageNo < 1) pageNo = 1;

            const format = moment().toMomentFormatString('MM.dd.yyyy');
            const searchFromAddDt = this.rangePicker.getStartDate()
                ? moment(this.rangePicker.getStartDate()).formatWithJDF(format)
                : '';
            const searchToAddDt = this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(format) : ''/*moment().formatWithJDF(format)*/;

            // param.put("requestType", param.get("requestType"));
            // param.put("approvalStatus", param.get("approvalStatus"));
            // param.put("requestUserName", param.get("requestUserName"));
            // param.put("account_no", param.get("account_no"));
            const params = {
                page: pageNo,
                requestType: this.selectedRequestType,
                approvalStatus: this.selectedApprovalStatus,
                requestUserName: this.requestUser === '' ? null : this.requestUser,
                account_no: this.accountNo,
                searchFromAddDt,
                searchToAddDt,
            };

            exclude.forEach(item => {
                if (item in params) delete params[item];
            });

            Vue.$log.info('search params', params);
            return params;
        },
        async search(pageNo) {
            if (typeof pageNo !== 'number' || pageNo < 1) pageNo = 1;

            // if (!this.validateSearchParams()) return; // Not needed

            const params = this.prepSearchParams(pageNo, ['hello', 'to_see']);

            SDLUtil.showLoadingBar(true);
            const { count, rows } = await this.fetchSearchResult(params);
            this.setSearchResultCount(count);
            this.setGridData(rows);

            SDLUtil.showLoadingBar(false);

            this.currentPage = pageNo;
        },
        fetchSearchResult(formData) {
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/FirstApproval/FirstApprovalSearch.skp`,
                    qs.stringify(formData),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: { searchInfo: 'set' },
                    },
                )
                .then(res => {
                    Vue.$log.info('SEARCH RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    return err;
                });
        },
        setSearchResultCount(count) {
            /* 
             * Server에서 결과가 0개일 때 항상 x개을 돌려주는 문제를 해결하는 if문
             * 20.08.07 - init() 실행 시 gridData 가 존재하는데 카운트가 0인 경우
             *          - TODO 케이스 확인 필요
             */
            let totCnt = Number(count);
            if(typeof(totCnt) === 'number' && String(totCnt) === 'NaN') {
                this.resultCount = 0;
            };

            if (count > 0 && this.gridData.length === 0) {
                this.resultCount = count;

            } else if(count === 0 && this.gridData.length > 0) {
                this.resultCount = 0;

            } else if(count === 0 && this.gridData.length === 0) {
                this.resultCount = 0;

            } else {
                this.resultCount = count;
            };
        },
        setGridData(data) {
            this.gridData = data;
            this.gridKey += 1;
        },
        switchMode(mode) {
            this.mode = mode;
            window.scrollTo(0, 0);
        },
        onGridRowClick(event, rowData) {
            if (typeof event.rowKey === 'undefined') return;
            Vue.$log.info('CLICKED ROW', rowData[event.rowKey]);
            const { GUBUN_CD, SEQ_NO } = rowData[event.rowKey];
            this.showDetail(GUBUN_CD, SEQ_NO);
        },
        showDetail(gubunCd, seqNo) {
            this.selectedGubunCd = gubunCd;
            this.selectedSeqNo = seqNo;
            this.switchMode(MODE.VIEW);
        },
        onBackToList(redoSearch = false) {
            this.switchMode(MODE.SEARCH);
            if (redoSearch) this.search();
        },
    },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/approvalManagement/FirstApprovalList.vue